import { type TaskType, TaskTypeValues } from "@remi/enums/task-type";
import { titleCase } from "@remi/formatting";
import { isOneOf } from "@remi/ts-utils";
import { TaskDisplay } from "@remi/types/tasks/task-display-settings";

// A tab on an older bundle receives task types added after it was built; maps keyed by TaskType have no entry for them.
export const isKnownTaskType = (taskType: string): taskType is TaskType => isOneOf(taskType, TaskTypeValues);

export const getTaskDisplayName = (taskType: string): string =>
  isKnownTaskType(taskType) ? TaskDisplay[taskType].name : titleCase(taskType);
